// MBQ OCT 2025 RESTYLING
import React, { Component, Fragment } from 'react'
import { Collapse, Navbar, NavbarToggler, NavbarBrand } from 'reactstrap'
import { Container, Row, Col } from 'reactstrap'
import { NavLink } from 'react-router-dom'
import { AuthConsumer } from 'react-check-auth'
import { ContentConsumer } from '../../language'
import SimpleNavList from './components/simpleNavList'
import { Colors } from './components/Colors'
import logo from '../../assets/images/logoOUPsolus_white.png'

const colors = ['red', 'pink', 'yellow', 'green', 'aqua', 'blue']

class SimpleHeader extends Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: false }
  }

  handleCollapse = () => this.setState(prevState => ({
    isOpen: !prevState.isOpen
  }))

  render() {
    const { isOpen } = this.state
    return (
      <div>
        <Navbar className="headerOUP" color="dark" expand="md">
          <AuthConsumer>
            {({ userInfo }) => (
              <ContentConsumer>
                {({ content }) => (content &&
                  <Fragment>
                    {
                      !userInfo ?
                        (
                          <NavbarBrand>
                            <Container fluid className='w-brand p-0 m-0'>
                              <Row className='w-brand'>
                                <Col className='w-brand logo'>
                                  <img src={logo} className="mr-2" alt="Oxford Premium" />
                                </Col>
                                <Col className='w-brand text'>
                                  <Row className='h-50 align-items-end'>Oxford</Row>
                                  <Row className='h-50'>Premium</Row>
                                </Col>
                              </Row>
                            </Container>
                          </NavbarBrand>
                        )
                        : (
                          <NavbarBrand tag={NavLink} to="/">
                            <Container fluid className='w-brand p-0 m-0'>
                              <Row className='w-brand'>
                                <Col className='w-brand logo'>
                                  <img src={logo} className="mr-2" alt="Oxford Premium" />
                                </Col>
                                <Col className='w-brand text'>
                                  <Row className='h-50 align-items-end'>Oxford</Row>
                                  <Row className='h-50'>Premium</Row>
                                </Col>
                              </Row>
                            </Container>
                          </NavbarBrand>
                        )
                    }
                    {
                      (userInfo) && (
                        <Fragment>
                          <NavbarToggler className="headerOUP__toggler" onClick={this.handleCollapse} />
                          <Collapse id="collapseTest" isOpen={isOpen} navbar>
                            <SimpleNavList
                              content={content}
                              userInfo={userInfo}
                            />
                          </Collapse>
                        </Fragment>
                      )
                    }
                  </Fragment>
                )}
              </ContentConsumer>
            )}
          </AuthConsumer>
        </Navbar>
        <Colors colors={colors} />
      </div>
    )
  }
}

export default SimpleHeader